import { AxiosResponse } from 'axios';
import { apiV2 } from '../http';
import {
  BulletinResponse,
  CreateBulletinInput,
  ResendBulletinInput,
  ResendBulletinResponse,
  UpdateBulletinInput,
} from '../interfaces/installation/bulletin';

export function getBulletins(
  idi: number,
): Promise<AxiosResponse<BulletinResponse[]>> {
  return apiV2.get(`installation/bulletin/${idi}`);
}

export function createBulletin(
  payload: CreateBulletinInput,
): Promise<AxiosResponse<BulletinResponse>> {
  return apiV2.post('installation/bulletin', payload);
}

export function updateBulletin(
  idi: number,
  bulletinId: number,
  payload: UpdateBulletinInput,
): Promise<AxiosResponse<BulletinResponse>> {
  return apiV2.patch(
    `installation/bulletin/${idi}/update/${bulletinId}`,
    payload,
  );
}

export function deleteBulletin(
  idi: number,
  bulletinId: number,
): Promise<AxiosResponse> {
  return apiV2.delete(`installation/bulletin/${idi}/delete/${bulletinId}`);
}

export function resendBulletin(
  idi: number,
  payload: ResendBulletinInput,
): Promise<AxiosResponse<ResendBulletinResponse>> {
  return apiV2.post(`installation/bulletin/${idi}/resend`, payload);
}
